const OSS = require('ali-oss');
import { generateOssConfig } from "./ossConfig"

const OSS_CONFIG = generateOssConfig('open');

let IDX = 256, HEX = [], SIZE = 256, BUFFER;
while (IDX--) HEX[IDX] = (IDX + 256).toString(16).substring(1);

function uid(len) {
    let i = 0, tmp = (len || 11);
    if (!BUFFER || ((IDX + tmp) > SIZE * 2)) {
        for (BUFFER = '', IDX = 0; i < SIZE; i++) {
            BUFFER += HEX[Math.random() * 256 | 0];
        }
    }

    return BUFFER.substring(IDX, IDX++ + tmp);
}

function dataFormat(fmt, date = new Date()) {
    const o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (const k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

function pathGenerate(filename) {
    return "front-oss/" + dataFormat("yyyy/MM/dd/hh/mm/") + uid(32) + "/" + filename;
}


function upload(ossConfig, data) {
    let ossClient = new OSS(OSS_CONFIG);
    // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
    let objectKey = pathGenerate(data.name);
    let result = ossClient.put(objectKey, data);
    console.debug(result);
    return result;
}
async function uploadImageByBase64(ossConfig, blob) {
    console.log(blob)
    let ossClient = new OSS(OSS_CONFIG);
    console.log(ossClient)

    // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
    let objectKey = pathGenerate(new Date().getTime());
    let result = await ossClient.put(objectKey, blob);
    console.debug(result);
    return result;
}
function multipartUpload(ossConfig, data, callback, extCallback) {
    if (process.env.VUE_APP_UPLOAD_PRIVATE) {
        let url = process.env.VUE_APP_UPLOAD_PRIVATE
        const formDate = new FormData()
        formDate.append('file', data)
        return instance.post(url, formDate, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(reslout => {
            return {
                code: reslout.data.code,
                res: {
                    requestUrls: [reslout.data.data]
                },
                name: reslout.data.data
            }
        })
    } else {
        let ossClient = new OSS(OSS_CONFIG);
        // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
        let objectKey = pathGenerate(data.name);
        let res = ossClient.multipartUpload(objectKey, data, {
            progress: function (p, checkpoint) {
                // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
                if (callback && callback instanceof Function) {
                    callback(p, checkpoint, data, extCallback);
                }
            }
        })
        return res;
    }
}

function ossFileUrl(ossConfig, path, cname) {
    if (process.env.VUE_APP_UPLOAD_PRIVATE) {
        return path
    }
    if (cname == null) {
        return 'https://' + OSS_CONFIG.bucket + '.' + OSS_CONFIG.region + '.aliyuncs.com/' + path;
    } else {
        return cname + '/' + path;
    }
}
const ossConfig = OSS_CONFIG

export {
    upload,
    multipartUpload,
    ossFileUrl,
    uploadImageByBase64,
    dataFormat,
    ossConfig,
    uid
}
